import { render } from "./PlayerVideoJs.vue?vue&type=template&id=4b86aa6d&scoped=true"
import script from "./PlayerVideoJs.vue?vue&type=script&lang=js"
export * from "./PlayerVideoJs.vue?vue&type=script&lang=js"

import "./PlayerVideoJs.vue?vue&type=style&index=0&id=4b86aa6d&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b86aa6d"]])

export default __exports__